import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listGenerationSalesMasters } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListGenerationSalesMastersRequestSchema,
  type ListGenerationSalesMastersResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 発電販売計画マスタ 一覧取得 hook。
 */
export function useListGenerationSalesMasters(): UseQueryResult<
  ListGenerationSalesMastersResponse,
  ConnectError
> {
  return useQuery(
    listGenerationSalesMasters,
    create(ListGenerationSalesMastersRequestSchema),
  )
}
